import addYears from 'date-fns/addYears';

export function getCalendarMaxDate(minDate: Date): Date {
  return addYears(minDate, 1);
}
